@if (team$ | async; as team) {
    <div class="display-team-membership-directive">
        <div class="team-detail-content"
             *adaptLoadingUntilFirstEmit="let teamMembers of activeTeamMembers$">
            @if (team.roleConnections.length === 0) {
                <p>No team members added yet</p>
            } @else {
                <ul class="d-flex gap-1">
                    @if (teamLeaderPerson) {
                        <li class="team-member-list-item team-leader-list-item">
                            <adapt-link-person class="team-leader-person-link"
                                               [imageSize]="imageSize"
                                               [person]="teamLeaderPerson"
                                               [attr.data-test]="'person-id-' + teamLeaderPerson.personId"
                                               [imageOnly]="true"
                                               [showPopover]="showPopover"></adapt-link-person>
                        </li>
                    }
                    @for (person of teamMembers; track person.personId) {
                        <li class="team-member-list-item">
                            <adapt-link-person [imageSize]="imageSize"
                                               [person]="person"
                                               [attr.data-test]="'person-id-' + person?.personId"
                                               [imageOnly]="true"
                                               [showPopover]="showPopover"></adapt-link-person>
                        </li>
                    }
                </ul>
            }
        </div>
    </div>
}
